<dx-popup
  [(visible)]="visible"
  [showTitle]="true"
  [title]="isEditing ? 'Modifier la Validation' : 'Valider l\'Intervention'"
  [dragEnabled]="true"
  [closeOnOutsideClick]="false"
  [width]="600"
  [height]="550"
  (onHiding)="close()">
  
  <div *dxTemplate="let data of 'content'">
    <div class="p-4 space-y-4">
      <div>
        <label class="block mb-2 font-medium">Précision des Données *</label>
        <div class="space-y-2">
          <dx-check-box
            *ngFor="let option of validationAccuracyOptions"
            [(value)]="option.checked"
            [text]="option.label"
            (onValueChanged)="onAccuracyChanged(option.value, $event.value)">
          </dx-check-box>
        </div>
      </div>

      <div>
        <label class="block mb-2 font-medium">Type d'Intervention *</label>
        <dx-select-box
          [(value)]="interventionType"
          [items]="interventionTypes"
          [searchEnabled]="true"
          displayExpr="label"
          valueExpr="value"
          placeholder="Sélectionnez un type">
        </dx-select-box>
      </div>

      <div>
        <label class="block mb-2 font-medium">Culture *</label>
        <dx-select-box
          [(value)]="cultureId"
          [items]="cultures"
          displayExpr="name"
          valueExpr="id"
          [searchEnabled]="true"
          placeholder="Sélectionnez une culture">
        </dx-select-box>
      </div>

      <div class="pt-2 border-t" *ngIf="!isEditing">
        <dx-check-box
          [(value)]="createFields"
          text="Valider et créer parcelles à partir des zones de travail"
          hint="Créera automatiquement des parcelles pour chaque zone de travail détectée">
        </dx-check-box>
        <p class="text-xs text-gray-500 mt-1 ml-6">
          Une parcelle sera créée pour chaque zone de travail verte détectée
        </p>
      </div>
    </div>
    
    <div class="p-4 border-t">
      <dx-button
        [text]="isEditing ? 'Modifier' : 'Valider'"
        type="success"
        (onClick)="validate()"
        [disabled]="!validationAccuracy || !interventionType || !cultureId"
        class="mr-2">
      </dx-button>
      <dx-button
        text="Annuler"
        (onClick)="close()">
      </dx-button>
    </div>
  </div>
</dx-popup>

